import C from './Constants';
import Hammer from 'hammerjs';

import { gsap, Power2 } from 'gsap';
import Draggable from 'gsap/Draggable';
import { Seat } from "./Seat";
import * as bootstrap from 'bootstrap';

gsap.registerPlugin(Draggable);

export default class ChooseSeats {
    constructor(props) {
        this.props = props;
        if (!$('.seat-suggestion').length || $(".seatfirst-arena").length) {
            return false;
        }
        this.el = $(".seat-selection");
        this.ticketsHeader = this.el.find('.seat-selection .header h5 span');
        this.seatsContainer = this.el.find('.seats');
        this.borderCompensate = this.el.find('.border-compensate');

        this.section = null;
        this.sectionData = null;
        this.oitemsInSection = null;

        this.availableSeats = null;
        this.listedSeats = [];
        this.groupedSeats = [];
        this.ungroupedSeats = [];
        this.ungroupedIndex = 0;
        this.confirmedSeats = null;

        this.seatDistancing = window.arenaInfo.fdSeating ?? 0;

        $('.section-seats').on('click', this._clearError);
        $('.section-container .error').on('click', this._clearError);

        this.dataStorage = this.props.dataStorage;
        this.state = this.dataStorage.state;

        // Binder om this 
        this._getNextSeatableIndex = this._getNextSeatableIndex.bind(this);
        this._onSectionDataLoaded = this._onSectionDataLoaded.bind(this);
        this._onSectionDataLoadError = this._onSectionDataLoadError.bind(this);
        this._onReserveSeatsComplete = this._onReserveSeatsComplete.bind(this);
        this._onReserveSeatsError = this._onReserveSeatsError.bind(this);
        this._selectHoveredSeats = this._selectHoveredSeats.bind(this);
        this._hoverSeatsOnMap = this._hoverSeatsOnMap.bind(this);
        this._ticketToggleBounce = this._ticketToggleBounce.bind(this);
        this._addPopover = this._addPopover.bind(this);
        this._removePopovers = this._removePopovers.bind(this);
        this._onWheel = this._onWheel.bind(this);
        this.resetViewport = this.resetViewport.bind(this);
        this.updateMiniMapMarker = this.updateMiniMapMarker.bind(this);
        this.btnZoom = this.btnZoom.bind(this);
        this._onPinch = this._onPinch.bind(this);
        this._onPinchStart = this._onPinchStart.bind(this);
        this._onPinchEnd = this._onPinchEnd.bind(this);
        this._toggleMiniMap = this._toggleMiniMap.bind(this);
        this._loadSeatsOnMap = this._loadSeatsOnMap.bind(this);
        this.svg = document.querySelector("#svg");
        this.svg.addEventListener("wheel", this._onWheel);
        $(".btnZoom").on("click", this.btnZoom);
        $("#btnToggleMap").on("click", this._toggleMiniMap);
        window.addEventListener('scroll', this._removePopovers);
        document.addEventListener("cartUpdateEvent", () => {
            //If an ticket is removed we need to re-draw the selected seats.
            this._loadSeatsOnMap();

        });
        // FOR MOBILE PINCH
        // =========================================================================== 
        this.isPinching = false;
        this.PinchCnt = 0;
        this.tPinching = null;
        this.startPinchPos = {};
        this.hammer = new Hammer(this.svg, { domEvents: true });
        this.hammer.get('pinch').set({ enable: true });

        this.hammer.on('pinchstart', this._onPinchStart);
        this.hammer.on('pinch', this._onPinch);
        this.hammer.on('pinchend', this._onPinchEnd);


        // VARIABLES
        this.proxy = document.createElement("div");
        this.viewBox = this.svg.viewBox.baseVal;
        this.svgMini = document.querySelector("#mapmini");
        this.mapMarker = document.querySelector("#mapMarker");
        this.viewBoxMini = this.svgMini.viewBox.baseVal;
        this.isDragging = false;
        this.lastPickedSeat = "";

        this.freeAllSeatsLimit = 0;
        this.useSeatsLimitRule = true;
        this.poi = null;


    }


    //
    //  PUBLIC: Updates Seats from datastorage
    //=========================================
    bind() {

        // Called to update
        if ($("#ChooseSeats-Component").is(":visible")) {
            this._loadSeatsOnMap();

        } else {
            this.section = null;
            this.sectionData = null;
            $('.poi-bottom').hide();
            $('.poi-top').hide();
        }


    }

    //
    //  PUBLIC: LOAD VIEW AFTER GETTING SEATS
    //=========================================
    loadSection(section, poi) {
        this._showLoader();


        if (!section) {
            return false;
        }

        this.section = section;
        this.poi = poi;

        const arrowAngle = this._getArrowAngle(poi);


        // Field below
        this.seatRotation = arrowAngle;

        if (arrowAngle) {
            const neutralArrowRotation = 90;
            if ((arrowAngle + neutralArrowRotation) >= 0 && (arrowAngle + neutralArrowRotation) <= 180) {
                $('.poi-bottom').show();
                $('.poi-top').addClass("whitebg")
            } else {
                $('.poi-bottom').hide();
                $('.poi-top').show();
                $('.poi-top').removeClass("whitebg")
            }

            $('.poi img').each(function () {
                $(this).css({ 'transform': 'rotate(' + arrowAngle + 'deg)' });
            });

            $('.arena-arrows img').each(function () {
                $(this).css({ 'transform': 'rotate(' + arrowAngle + 'deg)' });
            });
        } else {
            $('.poi-bottom, .poi-top').hide();
        }

        const url = C.STATIC_FILES ? C.SECTION_DATA_URL_STATIC : C.BASE_URL + C.SECTION_DATA_URL + section.code;
        $.ajax({
            dataType: 'json',
            url: url,
            data: {},
            success: this._onSectionDataLoaded,
            error: this._onSectionDataLoadError
        });
    }

    _onSectionDataLoadError(xhr, status, error) {
        let errorEl = $('.section-container .error');
        errorEl.show();
    }

    _clearError() {
        let errorEl = $('.section-container .error');
        errorEl.hide();
    }

    //
    //  LOAD VIEW AFTER GETTING SEATS
    //=========================================
    _onSectionDataLoaded(data, textStatus, xhr) {

        this.sectionData = data && data.length ? this._getDataByEventId(data) : null;
        if (!this.sectionData) {
            return false;
        }

        this.dataStorage.sectionData = this.sectionData;
        let allowedOitems = this.section.oitems;
        this.oitemsInSection = this.sectionData.orderItems.filter(function (x) {
            return allowedOitems.includes(x);
        });

        if (parseInt(xhr.status) !== 200) {
            this._onSectionDataLoadError(null, null, 'no 200 response code');
            return false;
        } else if (!this.sectionData || !this.sectionData.seats || !this.sectionData.seats.length) {
            this._onSectionDataLoadError(null, null, 'no-data or no-seats');
            return false;
        }

        this._checkUngroupedOption(this.sectionData.orderItems.length);

        this.point = this.svg.createSVGPoint();
        this.startClient = this.svg.createSVGPoint();
        this.startGlobal = this.svg.createSVGPoint();

        this._hideLoader();


        let cntOwn = this.dataStorage.GetCountInCurrentSection(this.section.code);

        if (this.section.ssrl !== undefined && this.section.ssrl != null && !isNaN(this.section.ssrl)) {
            this.freeAllSeatsLimit = this.section.ssrl * this.sectionData.seats.length / 100;
            this.useSeatsLimitRule = this.freeAllSeatsLimit < this.sectionData.seats.filter(function (s) {
                return s.available
            }).length + cntOwn;
            //
            console.log("SectionRule - Limit: ", this.section.ssrl + "%,  Total count seats in section: ", this.sectionData.seats.length);
            console.log("Use rule", this.useSeatsLimitRule)
            console.log(" ( Caluculated limit: ", this.freeAllSeatsLimit, " < Count free seats: ", this.sectionData.seats.filter(function (s) {
                return s.available
            }).length + " + Own seated: " + cntOwn + " )")
        } else {
            if (window.arenaInfo.ssrl !== undefined && window.arenaInfo.ssrl != null && !isNaN(window.arenaInfo.ssrl)) {
                this.freeAllSeatsLimit = window.arenaInfo.ssrl * this.sectionData.seats.length / 100;
                this.useSeatsLimitRule = this.freeAllSeatsLimit < this.sectionData.seats.filter(function (s) {
                    return s.available
                }).length + cntOwn;

                console.log("Global/ArenaRule - Limit: ", window.arenaInfo.ssrl + "%,  Totalt count seats in section: ", this.sectionData.seats.length);
                console.log("Use rule: ", this.useSeatsLimitRule)
                console.log(" ( Calculated limit: ", this.freeAllSeatsLimit, " < Count free seats: ", this.sectionData.seats.filter(function (s) {
                    return s.available
                }).length + " + Own seated: " + cntOwn + " )")
            } else {
                this.useSeatsLimitRule = false;
                console.log("NoRule");
            }
        }
        console.log("-----------------------");

        // get seats for section   
        this.mapWidth = 0;
        this.mapHeight = 0;
        this.padding = { x: 100, y: 100 };

        var displayAreaWidth = $(".section-container")[0].clientWidth;
        var displayAreaHeight = $(".section-container")[0].clientHeight;
        if (!displayAreaWidth) return; // If the view is not visible/loaded

        var displayRatio = displayAreaWidth / displayAreaHeight;
        var displayLeftMargin = 0;
        var displayTopMargin = 0;


        this.mapWidth = this.section.dimensions.x + 20;
        this.mapHeight = this.section.dimensions.y + 20;
        var mapRatio = this.mapWidth / this.mapHeight;

        this.mapWidth = this.mapHeight * displayRatio;
        if (this.mapWidth < this.section.dimensions.x) {
            this.mapWidth = this.section.dimensions.x + 20;
            this.mapHeight = this.mapWidth / displayRatio;
        }

        // Adjust SVG after display area
        displayLeftMargin = (this.mapWidth - this.mapHeight * mapRatio) / 2;


        displayLeftMargin = Math.max(0, displayLeftMargin);
        displayTopMargin = Math.max(0, displayTopMargin);

        $(".section-seats")[0].setAttribute("transform", "translate(" + displayLeftMargin + "," + displayTopMargin + ")");
        $(".section-seats")[1].setAttribute("transform", "translate(" + displayLeftMargin + "," + displayTopMargin + ")");

        this._loadSeatsOnMap();

        this.dragCnt = 0;
        // reset position
        this.viewBox.x = 0;
        this.viewBox.y = 0;

        this.viewBox.width = this.mapWidth;
        this.viewBox.height = this.mapHeight;
        this.viewBoxMini.width = this.mapWidth;
        this.viewBoxMini.height = this.mapHeight;

        this.isDragging = false;
        this.tDrag;

        this.cachedViewBox = {
            x: this.viewBox.x,
            y: this.viewBox.y,
            width: this.viewBox.width,
            height: this.viewBox.height
        };

        window.thisWasThis = this;
        this.zoom = {
            animation: gsap.timeline(),
            scaleFactor: 1.6,
            duration: 0.5,
            ease: Power2.easeOut,
        };

        var _this = this;
        this.pannable = new Draggable(this.proxy, {
            throwResistance: 3000,
            minimumMovement: 6,
            allowNativeTouchScrolling: false,
            trigger: this.svg,
            throwProps: true,
            onPress: function (e) {
                if (this.isPinching) {
                    return;
                }
                _this.selectDraggable(e, _this, this);
            },
            onDrag: function () {
                if (this.isPinching) {
                    return;
                }
                _this.dragCnt += 1;
                _this.isDragging = true;
                _this._onDrag(_this, this)
            },
            onThrowUpdate: function () {
                if (this.isPinching) {
                    return;
                }
                _this._onDrag(_this, this);
            },
            onDragStart: function () {
                if (this.isPinching) {
                    return;
                }
                _this.dragCnt = 0;
            },
            onDragEnd: function () {
                setTimeout(function () {
                    _this.isDragging = false;
                    _this.dragCnt = 0;
                }, 100);
            },
            onRelease: function () {
                setTimeout(function () {
                    _this.isDragging = false;
                    _this.dragCnt = 0;
                }, 100);
            }
        });

        this.pannableMini = new Draggable(this.mapMarker, {
            throwResistance: 3000,
            trigger: "#miniMap",
            bounds: "#miniMap",
            throwProps: true,
            onDrag: function () {
                _this.updateMiniMap(_this, this)
            },
            onThrowUpdate: function () {
                _this.updateMiniMap(_this, this)
            }
        });

        this.updateMiniMapMarker();
        this._hideLoader();
    }

    _getDataByEventId(data) {
        let eventId = parseInt($('.seat-suggestion').data('event-id'));
        if (!eventId || isNaN(eventId)) {
            return false;
        }

        let i = data.length;
        while (i--) {
            let event = data[i];
            if (event['eventId'] === eventId) {
                return event;
            }
        }

        return null;
    }


    // Draws all seats on the map
    // =========================================================================== 
    _loadSeatsOnMap() {
        $(".section-seats").empty();

        if (this.dataStorage.state === C.STATE_SEATS_UNGROUPED) {
            $(".visibleOnlyForUngrouped").show();
        } else {
            $(".visibleOnlyForUngrouped").hide();
        }

        this.allSeats = [];
        this.availableSeats = [];
        let seatKeys = this.dataStorage.GetCart().map(x => x.seatKey);
        let activeSeatKey = this.dataStorage.GetSelectedSeat().seatKey;


        const rotateSeat = this._calculateSeatRotation(this.poi);

        const icon = this.section.svgIcon || window.arenaInfo.svgIcon;

        this._renderSeatIcon(icon);

        this._renderSeats(this.sectionData.seats, rotateSeat, icon)
    }

    compareBySeatNumber(a, b) {
        return a.num - b.num;
    }

    _clearHoverSeatsOnMap(seat) {
        var seatsOnRow = this.allSeats.filter(function (aseat) {
            return aseat.row === seat.row;
        }).sort(this.compareBySeatNumber);
        for (var i = 0; i < seatsOnRow.length; i++) {
            seatsOnRow[i].clearHover();
        }
    }

    _addPopover(seats) {
        if (!Array.isArray(seats)) seats = [seats];

        const seatElements = seats
            .map(s => s.el)
            .filter(el => el instanceof Element);
        const seatKeys = seats
            .map(s => s.seatKey)
            .filter(Boolean);

        if (seatElements.length === 0 || seatKeys.length === 0) return;

        // --- Build popover content ---
        let contentHtml = '';
        if (seats.length === 1) {
            const parts = seatKeys[0].split('/');
            contentHtml = parts.length === 3
                ? `<b>Plats:</b> ${parts[2]}<br><b>Rad:</b> ${parts[1]}`
                : seatKeys[0];
        } else {
            const partsList = seatKeys.map(key => key.split('/'));
            const row = partsList[0][1];
            const seatNumbers = partsList
                .map(p => parseInt(p[2], 10))
                .sort((a, b) => a - b);

            contentHtml = `<b>Platser:</b> ${seatNumbers[0]}-${seatNumbers[seatNumbers.length - 1]}<br><b>Rad:</b> ${row}`;
        }



        // --- Anchor popover to the first seat in the group ---
        const targetEl = seatElements[0];

        //add class to target to be able to dispose the popover for next hover
        targetEl.classList.add('has-active-popover');
        targetEl.setAttribute('data-bs-toggle', 'popover');
        targetEl.setAttribute('data-bs-placement', 'top');
        targetEl.setAttribute('data-bs-html', 'true');

        const popover = new bootstrap.Popover(targetEl, {
            title: 'Sittplatsinfo',
            content: contentHtml,
            html: true,
            placement: 'top',
            trigger: 'manual',
            template: `
          <div class="popover arenaPopover" role="tooltip">
            <div class="popover-arrow"></div>
            <div class="popover-body p-1"></div>
          </div>
        `
        });

        popover.show();
    }

    _removePopovers() {

        document.querySelectorAll('[data-bs-toggle="popover"]').forEach(el => {
            const popoverInstance = bootstrap.Popover.getInstance(el);
            if (popoverInstance) {
                popoverInstance.hide();
            }
        });

        document.querySelectorAll('.popover').forEach(pop => pop.remove());
    }

    //
    /// Function to show hover seats
    //
    _hoverSeatsOnMap(seat) {        
        // Remove both 'hover' and 'notAvailableForSeating' classes from all matching elements
        document.querySelectorAll('.hover, .notAvailableForSeating').forEach(el => {
            el.classList.remove('hover', 'notAvailableForSeating');
        });
        let hoverlist = [];
        var seatsOnRow = this.allSeats.filter(function (aseat) {
            return aseat.row === seat.row;
        });
        var allRowLength = seatsOnRow.length;
        var min = seatsOnRow.reduce(function (prev, curr) {
            return prev.x < curr.x ? prev : curr;
        });
        var max = seatsOnRow.reduce(function (prev, curr) {
            return prev.x > curr.x ? prev : curr;
        });
        if (min.num > max.num) {
            seatsOnRow = seatsOnRow.sort(this.compareBySeatNumber).reverse();
        } else {
            seatsOnRow = seatsOnRow.sort(this.compareBySeatNumber);
        }
        var allInRow = seatsOnRow;

        let idx = seatsOnRow.indexOf(seat);
        if (idx === -1) return hoverlist;
        let startid = 0;
        for (var i = 0; i < idx; i++) {
            if (this.state == C.STATE_SEATS_UNGROUPED) {
                if (!seatsOnRow[idx - i].available) {
                    startid = idx - i + 1;
                    break;
                }
            } else {
                if (!seatsOnRow[idx - i].available && !seatsOnRow[idx - i].isSelected()) {
                    startid = idx - i + 1;
                    break;
                }
            }
        }
        var endId = seatsOnRow.length;
        for (var i = idx; i < seatsOnRow.length; i++) {
            if (this.state == C.STATE_SEATS_UNGROUPED) {
                if (!seatsOnRow[i].available) {
                    endId = i;
                    break;
                }
            } else {
                if (!seatsOnRow[i].available && !seatsOnRow[i].isSelected()) {
                    endId = i;
                    break;
                }
            }
        }
        seatsOnRow = seatsOnRow.slice(startid, endId);
        // adjustments of idx
        if (startid > 0) {
            idx = idx - startid;
        }
        if (idx === -1) {
            idx = 0
        }
        ;
        let _this = this;
        let cnt = this.dataStorage.GetCart().length;
        if (this.state === C.STATE_SEATS_GROUPED) {
        } else {
            cnt = 1;
        }

        if (cnt > seatsOnRow.length) {
            for (var i = idx; i < seatsOnRow.length; i++) {
                seatsOnRow[i].notAvailableForSeating();
            }
            return hoverlist;
        }

        //Efter Sista stolen fall
        if (idx + cnt >= seatsOnRow.length) {
            idx = seatsOnRow.length - cnt;
        }


        if (this.seatDistancing > 0) {
            //
            // CORONA DISTANCING CASE
            //

            // case: skip first
            if (startid == 0) {
                if (this.state == C.STATE_SEATS_UNGROUPED) {
                    if (idx == 0 && !seatsOnRow[0].isSelected()) {
                        for (var i = idx; i < idx + cnt; i++) {
                            seatsOnRow[i].notAvailableForSeating();
                        }
                        return hoverlist;
                    }
                } else {
                    if (idx == 0) {
                        for (var i = idx; i < idx + cnt; i++) {
                            seatsOnRow[i].notAvailableForSeating();
                        }
                        return hoverlist;
                    }
                }
            } else {
                // By setting

                if (this.state == C.STATE_SEATS_UNGROUPED) {
                    var isFirstUsersSelected = allInRow[startid - 1].isSelected();
                    if (!isFirstUsersSelected && idx < this.seatDistancing) {
                        for (var i = idx; i < idx + cnt; i++) {
                            seatsOnRow[i].notAvailableForSeating();
                        }
                        return hoverlist;
                    }
                } else {
                    if (idx < this.seatDistancing) {
                        for (var i = idx; i < idx + cnt; i++) {
                            seatsOnRow[i].notAvailableForSeating();
                        }
                        return hoverlist;
                    }
                }
            }

            //case: last chair
            if (endId == allRowLength) {
                if (idx + cnt == seatsOnRow.length) {
                    for (var i = idx; i < seatsOnRow.length; i++) {
                        seatsOnRow[i].notAvailableForSeating();
                    }
                    return hoverlist;
                }
            } else {
                // By setting
                var isLastUsersSelected = endId + 1 < allRowLength ? allInRow[endId].isSelected() : true;
                if (!isLastUsersSelected && idx + cnt + this.seatDistancing > seatsOnRow.length) {
                    for (var i = idx; i < seatsOnRow.length; i++) {
                        seatsOnRow[i].notAvailableForSeating();
                    }
                    return hoverlist;
                }
            }
        }


        if (this.useSeatsLimitRule && this.seatDistancing == 0) {

            // Rules

            // Case: skip first seat
            if (this.state == C.STATE_SEATS_UNGROUPED) {
                if (idx == 1 && !seatsOnRow[0].isSelected()) {
                    for (var i = idx; i < idx + cnt; i++) {
                        seatsOnRow[i].notAvailableForSeating();
                    }
                    return hoverlist;
                }
            } else {
                if (idx == 1) {
                    for (var i = idx; i < idx + cnt; i++) {
                        seatsOnRow[i].notAvailableForSeating();
                    }
                    return hoverlist;
                }
            }


            // Case: skip last seat
            if (idx + cnt + this.seatDistancing == seatsOnRow.length - 1) {
                for (var i = idx; i < seatsOnRow.length - 1; i++) {
                    seatsOnRow[i].notAvailableForSeating();
                }
                return hoverlist;
            }
        }

        for (var i = idx; i < idx + cnt; i++) {
            seatsOnRow[i].hover();
            hoverlist.push(seatsOnRow[i]);
        }

        return hoverlist
    }

    _ticketToggleBounce() {
        const toggleButton = document.getElementById('panelToggleBtn');
        if (!toggleButton) return;

        toggleButton.classList.remove("bounce");
        void toggleButton.offsetWidth; 
        toggleButton.classList.add("bounce");
    }

    // GROUPSELECTION
    _reserveSeats(seats, selectedSeat) {
        if (!seats || !seats.length) {
            return false;
        }

        this._showLoader50();
        let bodyData = [];
        if (this.state === C.STATE_SEATS_UNGROUPED) {
            const index = this.dataStorage.GetSelectedSeatIndex();
            bodyData.push({
                'OrderItemId': this.dataStorage.GetCart()[index].id,
                'SeatKey': selectedSeat.seatKey
            });
        } else {
            seats.map((seat, index) => {
                bodyData.push({
                    'OrderItemId': this.dataStorage.GetCart()[index].id,
                    'SeatKey': seat.seatKey
                });
            });
        }
        seats = seats.filter(val => val);
        const url = C.BASE_URL + C.RESERVE_SEATS_URL + this.sectionData.orderId;
        $.ajax({
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            type: 'POST',
            url: url,
            data: JSON.stringify({ List: bodyData }),
            success: (data, textStatus, xhr) => {
                this._onReserveSeatsComplete(data, textStatus, xhr, seats, selectedSeat);
            },
            error: (xhr, status, error) => {
                this._onReserveSeatsError(xhr, status, error, seats, selectedSeat);
            }
        });
    }

    _onReserveSeatsError(xhr, status, error, seats, selectedSeat) {
        let errorEl = $('.section-container .error');
        errorEl.show();

        this._hideLoader();

        // CLEAR PICKED SEATS
        if (this.state === C.STATE_SEATS_UNGROUPED) {
            selectedSeat.unpicked();
            selectedSeat.error();
        } else {
            seats.forEach((seat, index) => {
                // one of the seats is bad, error-mark all
                seat.unpicked();
                seat.error();
            });
        }
    }

    _onReserveSeatsComplete(data, textStatus, xhr, seats, selectedSeat) {

        const isOk = parseInt(xhr.status) === 200;
        const { cartItems } = data || {};

        if (!isOk) {
            this._onReserveSeatsError(xhr, textStatus, 'no 200 response code', seats, selectedSeat);
            return;
        }
        if (!Array.isArray(cartItems) || !cartItems.length) {
            this._onReserveSeatsError(xhr, textStatus, 'empty-cart', seats, selectedSeat);
            return;
        }

        this.confirmedSeats = seats.slice();
        this._hideLoader();

        this.dataStorage.cart = cartItems;
        this.dataStorage.SetSelectedSeat(this.dataStorage.GetCart()[this._getNextSeatableIndex()]);
        this.props.onSeatClick(selectedSeat);

        $(".map .seat.picked").removeClass('picked');
        cartItems.forEach((seat) => {
            $("#" + seat.seatKey.replace(/\//g, "-"), svg).addClass('picked');
        });
    }
    // Centers the chairs on the map
    _centerSeatsContainer() {
        let x, y;
        const sectionSeats = $('.section-seats');
        if (this.section.startPosition) {
            x = this.section.startPosition.x - this.section.arenaCords.x;
            y = this.section.startPosition.y - this.section.arenaCords.y;

        } else {
            const sectionContainer = $('.section-container');
            x = Math.round((sectionContainer.width() - sectionSeats.width()) * .5);
            y = Math.round((sectionContainer.height() - sectionSeats.height()) * .5);
        }
        sectionSeats.css({ left: -x, top: -y });
    }

    _checkUngroupedOption(numTickets) {
        if (!numTickets || numTickets <= 1) {
            $('.ungroup-option').hide();
        } else {
            $('.ungroup-option').show();
        }
    }

    _hideLoader() {
        let loader = $('.section-container .loader');
        if (loader)
            loader.removeClass('opacity').fadeOut(300);
    }

    _showLoader() {
        let loader = $('.section-container .loader');
        loader.show();
    }

    _showLoader50() {
        let loader = $('.section-container .loader');
        loader.addClass('opacity').show();
    }

    _getArrowAngle(poi) {
        if (!poi)
            return null;
        let sectionPos = this.section.arenaCords;
        let sectionSz = this.section.dimensions;

        let sectionCenterX = sectionPos.x + sectionSz.x / 2;
        let sectionCenterY = sectionPos.y + sectionSz.y / 2;

        let distY = poi.y - sectionCenterY,
            distX = poi.x - sectionCenterX;
        let radians = Math.atan2(distY, distX);
        let degrees = radians * 180 / Math.PI;

        return degrees - 90;
    }

    //
    // ON SELECT SEAT ON SVG-MAP
    // =========================================================================== 
    _onSelectSeat(seat) {
        if (this.isPinching) {
            this.isPinching = false;
            return
        }

        if (this.isDragging && this.dragCnt > 1) {
            return
        }

        if (this.lastPickedSeat.seatKey === seat.seatKey) {
            return
        }

        this.lastPickedSeat = seat;
        switch (this.state) {
            case C.STATE_SEATS_UNGROUPED:

                if (!seat.isAvailableForSeating()) return;

                const seats = [...this.dataStorage.GetCart()];
                const seatIndex = this.dataStorage.GetSelectedSeatIndex();
                seats[seatIndex] = seat;
                this._reserveSeats(seats, seat);
                break;

            default:
                this._selectHoveredSeats(seat);

        }
    }

    _selectHoveredSeats(seat) {
        const seats = this._hoverSeatsOnMap(seat);
        // loop over the seats we selected
        let i = seats.length;
        while (i--) {
            seats[i].picked();
        }

        // make server call to make sure we actually can reserve selected seats
        this._reserveSeats(seats.slice());
    }

    _getNextSeatableIndex() {

        let currentIndex = this.dataStorage.GetSelectedSeatIndex();
        var nextIdx = currentIndex + 1;
        if (nextIdx > this.dataStorage.GetCart().length - 1) {
            nextIdx = 0;
        }

        var i = 0;
        var newIndexFound = false;

        do {
            var seatable = this.section.oitems.includes(this.dataStorage.GetCart()[nextIdx].id)
            if (seatable) {
                newIndexFound = true;
            } else {
                nextIdx++;
                if (nextIdx > this.dataStorage.GetCart().length - 1) {
                    nextIdx = 0;
                }
                i++;
            }
        } while (!newIndexFound && i < this.dataStorage.GetCart().length);
        return nextIdx;
    }

    _toggleMiniMap() {
        var _this = this;
        const mapChevron = document.getElementById("map-chevron");

        $('#miniMap').slideToggle('fast', function () {
            var visible = $('#miniMap').is(":visible");
            $("#btnToggleMap").toggleClass('hide', !visible);
            if (visible) {
                _this.updateMiniMapMarker();

                if (mapChevron) {
                    mapChevron.style.transform = 'rotate(0deg)';
                }

            }
            else {
                if (mapChevron) {
                    mapChevron.style.transform = 'rotate(180deg)';
                }
            }
        });


    }
    //
    // ON WINDOW RESIZE
    // =========================================================================== 
    onResize() {
        if (this.section) {
            this.resetViewport();
        }
    }
    //
    // RESET VIEWPORT
    // =========================================================================== 
    resetViewport() {

        if (this.pannable.tween) {
            this.pannable.tween.kill();
        }


        this.mapWidth = 0;
        this.mapHeight = 0;
        this.padding = { x: 100, y: 100 };

        const sectionContainer = $('.section-container');
        const displayAreaWidth = sectionContainer[0].clientWidth;
        const displayAreaHeight = sectionContainer[0].clientHeight;
        if (displayAreaWidth === 0 || displayAreaHeight === 0) {
            return;
        }

        const displayRatio = displayAreaWidth / displayAreaHeight;
        let displayLeftMargin = 0;
        let displayTopMargin = 0;

        this.mapWidth = this.section.dimensions.x + 20;
        this.mapHeight = this.section.dimensions.y + 20;
        let mapRatio = this.mapWidth / this.mapHeight;

        this.mapWidth = this.mapHeight * displayRatio;
        if (this.mapWidth < this.section.dimensions.x) {
            this.mapWidth = this.section.dimensions.x + 20;
            this.mapHeight = this.mapWidth / displayRatio;
        }

        // Adjust SVG after display view 
        displayLeftMargin = (this.mapWidth - this.mapHeight * mapRatio) / 2;


        displayLeftMargin = Math.max(0, displayLeftMargin);
        displayTopMargin = Math.max(0, displayTopMargin);

        $(".section-seats")[0].setAttribute("transform", "translate(" + displayLeftMargin + "," + displayTopMargin + ")");
        $(".section-seats")[1].setAttribute("transform", "translate(" + displayLeftMargin + "," + displayTopMargin + ")");


        // Keep scale zoom...
        this.viewBox.width = this.mapWidth;
        this.viewBox.height = this.mapHeight;
        this.viewBoxMini.width = this.mapWidth;
        this.viewBoxMini.height = this.mapHeight;

        this.cachedViewBox.width = this.mapWidth;
        this.cachedViewBox.height = this.mapHeight;

        this.viewBox.x = this.cachedViewBox.x;
        this.viewBox.y = this.cachedViewBox.y;
        this.viewBoxMini.x = this.cachedViewBox.x;
        this.viewBoxMini.y = this.cachedViewBox.y;

        this.updateMiniMapMarker();

    }
    //
    //ON PINCH START
    //===========================================================================
    _onPinchStart(ev) {
        try {
            this.isPinching = true;

            this.point.x = ev.center.x;
            this.point.y = ev.center.y;
            const pinchZoomOriginCalc = this.point.matrixTransform(this.svg.getScreenCTM().inverse());

            this.pinchZoomOrigin = {
                x: pinchZoomOriginCalc.x,
                y: pinchZoomOriginCalc.y
            };

            this.startPinch = {
                //ease: this.zoom.ease,
                x: this.viewBox.x,
                y: this.viewBox.y,
                width: this.viewBox.width,
                height: this.viewBox.height,
            };

        } catch (e) {

        }
    }
    //
    //ON PINCH
    //===========================================================================
    _onPinch(ev) {

        this.isPinching = true;
        const _this = this;

        if (_this.zoom.animation.isActive()) {
            return;
        }

        try {

            const scale = Math.round(1000 / ev.scale) / 1000; // Normalize

            this.point.x = ev.center.x;
            this.point.y = ev.center.y;

            const x = this.startPinch.x - ((this.pinchZoomOrigin.x - this.startPinch.x)) * (scale - 1)
            const y = this.startPinch.y - ((this.pinchZoomOrigin.y - this.startPinch.y)) * (scale - 1);


            // Zoombounds
            let initW = this.viewBox.width;
            this.viewBox.width = (Math.min(this.startPinch.width * scale, this.cachedViewBox.width));
            this.viewBox.height = (Math.min(this.startPinch.height * scale, this.cachedViewBox.height));

            if (initW !== this.viewBox.width) {
                this.viewBox.x = (Math.min(this.cachedViewBox.width - this.viewBox.width + this.padding.x, Math.max(x, -1 * this.padding.x)));
                this.viewBox.y = (Math.min(this.cachedViewBox.height - this.viewBox.height + this.padding.y, Math.max(y, -1 * this.padding.y)));
            }
            this.updateMiniMapMarker();

        } catch (e) {
            console.error(e);
        }
    }
    //
    // ON PINCH OUT
    //===========================================================================
    _onPinchEnd(ev) {
        const _this = this;
        clearTimeout(_this.tPinching);
        _this.tPinching = setTimeout(function () {
            _this.isPinching = false;
            _this.PinchCnt = 0;
        }, 300);
    }
    //
    //ON BTN ZOOM
    //===========================================================================    
    btnZoom(ev) {

        const scale = ev.target.getAttribute("data-scale");

        const _this = this;
        const fromVars = {
            ease: this.zoom.ease,
            x: this.viewBox.x,
            y: this.viewBox.y,
            width: this.viewBox.width,
            height: this.viewBox.height,
            onComplete: function () {
                _this.updateMiniMapMarker()
            }
        };

        // calculate center
        const x = this.viewBox.x - ((this.viewBox.x + this.viewBox.width / 2) - this.viewBox.x) * (scale - 1);
        const y = this.viewBox.y - ((this.viewBox.y + this.viewBox.height / 2) - this.viewBox.y) * (scale - 1);
        this.viewBox.width *= scale;
        this.viewBox.height *= scale;

        // Zoombounds
        this.viewBox.width = Math.min(this.viewBox.width, this.cachedViewBox.width);
        this.viewBox.height = Math.min(this.viewBox.height, this.cachedViewBox.height);

        this.viewBox.x = Math.min(this.cachedViewBox.width - this.viewBox.width, Math.max(x, 0));
        this.viewBox.y = Math.min(this.cachedViewBox.height - this.viewBox.height, Math.max(y, 0));

        this.zoom.animation = gsap.from(this.viewBox, this.zoom.duration, fromVars);


    }
    //
    // ON WHEEL
    //===========================================================================
    _onWheel(event) {
        event.preventDefault();
        let normalized;
        let delta = event.wheelDelta;

        if (delta) {
            normalized = (delta % 120) === 0 ? delta / 120 : delta / 12;
        } else {
            delta = event.deltaY || event.detail || 0;
            normalized = -(delta % 3 ? delta * 10 : delta / 3);
        }

        const scaleDelta = normalized > 0 ? 1 / this.zoom.scaleFactor : this.zoom.scaleFactor;

        this.point.x = event.clientX;
        this.point.y = event.clientY;
        const startPoint = this.point.matrixTransform(this.svg.getScreenCTM().inverse());

        const _this = this;
        const fromVars = {
            ease: this.zoom.ease,
            x: this.viewBox.x,
            y: this.viewBox.y,
            width: this.viewBox.width,
            height: this.viewBox.height,
            onComplete: function () {
                _this.updateMiniMapMarker()
            }
        };

        const x = this.viewBox.x - (startPoint.x - this.viewBox.x) * (scaleDelta - 1);
        const y = this.viewBox.y - (startPoint.y - this.viewBox.y) * (scaleDelta - 1);
        this.viewBox.width *= scaleDelta;
        this.viewBox.height *= scaleDelta;


        // Zoombounds         
        this.viewBox.width = Math.min(this.viewBox.width, this.cachedViewBox.width);
        this.viewBox.height = Math.min(this.viewBox.height, this.cachedViewBox.height);

        this.viewBox.x = Math.min(this.cachedViewBox.width - this.viewBox.width, Math.max(x, 0));
        this.viewBox.y = Math.min(this.cachedViewBox.height - this.viewBox.height, Math.max(y, 0));

        this.zoom.animation = gsap.from(this.viewBox, this.zoom.duration, fromVars);


    }

    //
    // SELECT DRAGGABLE
    // =========================================================================== 
    selectDraggable(event, _this, _this2) {
        try {


            _this.startClient.x = _this2.pointerX;
            _this.startClient.y = _this2.pointerY;
            _this.startGlobal = _this.startClient.matrixTransform(_this.svg.getScreenCTM().inverse());


            // Right mouse button
            if (event.button === 2) {
                event.preventDefault();
            } else {

                gsap.set(this.proxy, {
                    x: _this2.pointerX,
                    y: _this2.pointerY
                });

                if (event.target != null && event.target.nodeName == "circle" || event.target.nodeName == "path") {
                    _this.pannable.enable().update();
                } else {
                    _this.pannable.enable().update().startDrag(event);
                }

            }
        } catch (e) {
        }
    }


    //
    // on DRAG 
    // =========================================================================== 
    _onDrag(_this, _thisEl) {

        if (_this.isPinching) {
            return;
        }
        if (_this.zoom.animation.isActive()) {
            return;
        }
        if (!_this.pannable.isDragging) {
            return;
        }

        _this.point.x = _thisEl.x;
        _this.point.y = _thisEl.y;

        const moveGlobal = _this.point.matrixTransform(_this.svg.getScreenCTM().inverse());

        _this.viewBox.x -= (moveGlobal.x - _this.startGlobal.x);
        _this.viewBox.y -= (moveGlobal.y - _this.startGlobal.y);

        // Bound check
        _this.viewBox.x = Math.min(_this.cachedViewBox.width - _this.viewBox.width + this.padding.x, Math.max(_this.viewBox.x, -1 * this.padding.x));
        _this.viewBox.y = Math.min(_this.cachedViewBox.height - _this.viewBox.height + this.padding.y, Math.max(_this.viewBox.y, -1 * this.padding.y));

        _this.updateMiniMapMarker();

    }


    //
    // UPDATE MINIMAP MARKER
    // =========================================================================== 
    updateMiniMapMarker() {
        if (this.svgMini.clientWidth == 0) {
            $(this.mapMarker).addClass("hidden");
            return;
        }

        $(this.mapMarker).removeClass("hidden");
        const mapSvgDomScale = this.svg.clientWidth / this.cachedViewBox.width;
        const mapRelationScaleWidth = this.svgMini.clientWidth / this.svg.clientWidth;
        const mapRelationScaleHeight = this.svgMini.clientHeight / this.svg.clientHeight;
        const zoomScale = this.viewBox.width / this.cachedViewBox.width;

        gsap.set(this.mapMarker, {
            x: this.viewBox.x * mapRelationScaleWidth * mapSvgDomScale,
            y: this.viewBox.y * mapRelationScaleHeight * mapSvgDomScale,
            width: Math.max(this.svg.clientWidth, 0) * mapRelationScaleWidth * zoomScale,
            height: Math.max(this.svg.clientHeight, 0) * mapRelationScaleWidth * zoomScale,
            force3D: true,
            transformOrigin: "left top"
        });
    }


    //
    // UPDATE MINIMAP
    // =========================================================================== 
    updateMiniMap(_this, _thisEl) {
        var mapOrgScale = _this.svg.clientWidth / _this.cachedViewBox.width;
        var mapRelationScale = _this.svgMini.clientWidth / _this.svg.clientWidth;

        _this.viewBox.x = Math.min((_this.cachedViewBox.width - _this.viewBox.width + this.padding.x), Math.max(_thisEl.x / (mapRelationScale * mapOrgScale), -1 * this.padding.x));
        _this.viewBox.y = Math.min((_this.cachedViewBox.height - _this.viewBox.height + this.padding.y), Math.max(_thisEl.y / (mapRelationScale * mapOrgScale), -1 * this.padding.y));
    }

    _renderSeatIcon(icon) {
        // Set icons on icondescriptionbar    
        const svgSeatIcon = $(".section-container-icons .mapicon");
        switch (icon) {
            case "circle":
                svgSeatIcon.attr("d", "M 0,0 m -10, 0 a 10, 10 0 1,0 20,0 a 10,10 0 1,0 -20,0");
                svgSeatIcon.attr('fill', "transparent");
                svgSeatIcon.attr('transform', "");
                break;
            default:
                svgSeatIcon.attr("d", "M2.62,12.4l13.2,0m1.62,1V7.74M.5,13.43S.5,15.5,9,15.5s8.47-2.07,8.47-2.07M.5,7.74v5.69M15.85,8.26H18M.5,8.26H2.62m12.7,4.65V3A9.59,9.59,0,0,0,2.49,3l.13,10"); //Set path's data     
                svgSeatIcon.attr('transform-origin', "0 0");
                svgSeatIcon.attr('fill', "#ffffff");
                svgSeatIcon.attr('transform', "translate(-9,-9), rotate(0)");
        }
    }

    /**
     * Calculates the rotation angle (in degrees) needed to make a seat icon
     * face toward the current point of interest (POI).
     *
     * Assumes that the seat icon is visually drawn pointing *upward* when rotation is 0°,
     * but mathematical 0° is pointing *right*. To align the icon's visual direction
     * with mathematical direction, we apply a +90° correction.
     *
     * @param {Object} poi - The point of interest to face toward, with {x, y} coordinates
     * @returns {number} rotation angle in degrees (0–359), clockwise from the SVG's 0°
     */
    _calculateSeatRotation(poi) {
        if (!poi) {
            console.error("No POI");
            return 0;
        }

        // Calculate the center of the section this seat belongs to
        const sectionCenter = {
            x: this.section.arenaCords.x + this.section.dimensions.x / 2,
            y: this.section.arenaCords.y + this.section.dimensions.y / 2,
        };

        // Vector from the section center to the POI
        const dx = poi.x - sectionCenter.x;
        const dy = poi.y - sectionCenter.y;

        // Convert vector to angle in degrees (mathematical 0° = right)
        let angle = Math.atan2(dy, dx) * (180 / Math.PI);

        // Convert to clockwise system and normalize to 0–359
        // Add 90° because the seat icon is drawn pointing UP, not RIGHT
        angle = (angle + 90 + 360) % 360;

        return angle;
    }

    _calculateSeatRotationOld(poi) {
        return 0;

        if (!poi) return 180;

        const seatsOnRow = this.sectionData.seats.filter(seat => seat.row === this.sectionData.seats[0].row);
        const miny = seatsOnRow.reduce((prev, curr) => Number(prev.y) < Number(curr.y) ? prev : curr);
        const maxy = seatsOnRow.reduce((prev, curr) => Number(prev.y) > Number(curr.y) ? prev : curr);
        const minx = seatsOnRow.reduce((prev, curr) => Number(prev.x) < Number(curr.x) ? prev : curr);
        const maxx = seatsOnRow.reduce((prev, curr) => Number(prev.x) > Number(curr.x) ? prev : curr);

        const dx = Math.abs(minx.x - maxx.x);
        const dy = Math.abs(miny.y - maxy.y);

        const rot = (this.seatRotation + 360) % 360; // Normalize rotation
        if (dx > 5 && dy > 5) {
            if (rot > 0 && rot < 90) return 225;        // TOP RIGHT
            if (rot > -270 && rot < -180) return -45;   // BOTTOM RIGHT
            if (rot > -180 && rot < -90) return 45;     // BOTTOM LEFT
            if (rot > -90 && rot < 0) return 135;       // TOP LEFT
        } else if (dx > 5) {
            return this.section.arenaCords.y - poi.y > 0 ? 0 : 180;
        } else if (dy > 5) {
            return this.section.arenaCords.x - poi.x > 0 ? 270 : 90;
        }

        return 180;
    }

    _renderSeats(seatData, rotateSeat, icon) {
        this.allSeats = [];
        this.availableSeats = [];

        const seatKeys = this.dataStorage.GetCart().map(x => x.seatKey);
        const activeSeatKey = this.dataStorage.GetSelectedSeat().seatKey;
        const isGrouped = this.dataStorage.state === C.STATE_SEATS_GROUPED;

        seatData.forEach(seatDatum => {
            const seat = new Seat({
                data: seatDatum,
                offset: this.section.arenaCords,
                leftMargin: 0,
                topMargin: 0,
                rotate: rotateSeat,
                iconpath: icon
            });

            this.allSeats.push(seat);
            let available = true;
            const availableSeats = seatDatum.oitems;

            if (availableSeats?.length > 0) {
                if (isGrouped) {
                    for (const cartItem of this.dataStorage.GetCart()) {
                        if (!availableSeats.includes(cartItem.id)) {
                            seat.available = false;
                            seat.unavailable();
                            available = false;
                            break;
                        }
                    }
                } else {
                    if (!availableSeats.includes(this.dataStorage.GetSelectedSeat().id)) {
                        seat.available = false;
                        seat.unavailable();
                        available = false;
                    }
                }
            } else {
                seat.available = false;
                seat.unavailable();
                available = false;
            }

            // Check if in cart
            if (seatKeys.includes(seat.seatKey)) {
                if (!isGrouped && activeSeatKey === seat.seatKey) {
                    seat.active();
                } else {
                    seat.available = false;
                    seat.picked();
                }
            }

            if (!available) return;

            this._bindSeatEvents(seat);

            this.availableSeats.push(seat);
        });
    }

    _bindSeatEvents(seat) {
        const $el = $(seat.el);
        $el.on('click touchend', (e) => {
            if (this.isPinching || this.isDragging) return;
            e.stopPropagation();
            e.preventDefault();
            e.stopImmediatePropagation();
            this._clearError();
            this._hoverSeatsOnMap(seat);

            if (seat.isAvailableForSeating()) {
                this._onSelectSeat(seat);
                this._ticketToggleBounce();

            }
        });
        $el.on('mouseover', () => {
            const seatsHovered = this._hoverSeatsOnMap(seat);
            this._addPopover(seatsHovered);
        });

        $el.on('mouseout', () => {
            this._clearHoverSeatsOnMap(seat);
            this._removePopovers();
        });


        $el.on('touchstart', () => {
            this._clearHoverSeatsOnMap(seat);
            this._removePopovers();
            const seatsHovered = this._hoverSeatsOnMap(seat);
            this._addPopover(seatsHovered);
        });

        $el.on('scroll', () => {
            this._removePopovers();
        });


    }

    
}
